import sentenceTo from './sentence-to';
export default sentenceTo('-');
